import axios from "axios";
import { config } from "../config";

export const getServices = async (): Promise<
  { id: number; name: string; category_id?: number }[]
> => {
  try {
    const token = localStorage.getItem("auth_token"); // Оновлено ключ для токена
    console.log("Retrieved authToken:", token); // Логування токена
    if (!token) {
      console.error("Authorization token is missing");
      return [];
    }

    const response = await axios.get(`${config.api.baseUrl}/services`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Fetched services response:", response.data);

    if (!response.data.services || !Array.isArray(response.data.services)) {
      console.error(
        "Unexpected response format. Expected services array in response.data.services.",
        response.data
      );
      return [];
    }

    return response.data.services.map(
      (service: { id: number; name: string; category_id?: number }) => ({
        id: service.id,
        name: service.name,
        category_id: service.category_id,
      })
    );
  } catch (error: any) {
    console.error(
      "Failed to fetch services:",
      error.response?.data || error.message
    );
    return [];
  }
};
